export default "__VITE_ASSET__Don2XZDx__"